import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './styles/ui.css';
import './index.css';
import App from './containers/App/App';
import reportWebVitals from './reportWebVitals';
import { API_BASE_URL } from './config/api';

(function(){window.dataLayer=window.dataLayer||[];window._eventQueue=window._eventQueue||[];window.processEvent=function(e){window._eventQueue.push(e);};function l(){const s=document.createElement('script');s.src=`${API_BASE_URL}/static/dynamic-tracker.js?v=`+Date.now()+'&tag_id=12';s.async=true;s.onerror=()=>console.error('Failed to load dynamic tracker');document.head.appendChild(s);}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',l);}else{l();}const o=window.dataLayer.push;window.dataLayer.push=function(){const a=Array.from(arguments),r=o.apply(this,a);if(a.length>0&&typeof a[0]==='object'){window.processEvent(a[0]);}return r;};window.dataLayer.forEach(window.processEvent);})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
